<h2>{{ header }}</h2>
<span [innerHTML]="message"></span>
